<template>
  <div>
    <div class="flex items-center justify-between p-[12px] border-t">
      <div class="font-semibold text-black text-[12px]">
        Informasi Order
      </div>
      <div class="flex items-center gap-[10px]">
        <b-input-group class="!w-auto">
          <flat-pickr
            v-model="month"
            class="!rounded-l-lg !w-[100px] !font-semibold !text-black"
            :config="flatpickrMonthly"
            @on-change="onChangeMonth"
          />
          <b-input-group-append class="!border rounded-r-lg px-[5px] !border-[#d8d6de]">
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/calendar.svg"
              width="20"
              alt="calendar"
            >
          </b-input-group-append>
        </b-input-group>

        <b-button
          variant="ghost"
          size="sm"
          class="!rounded-full hover:bg-[#f4f4f4] !p-0 !size-8 !flex items-center justify-center"
          @click="toggleDetail"
        >
          <span
            class="k-arrow-down-1"
            :class="{ 'rotate-180': showDetail }"
          />
        </b-button>
      </div>
    </div>
    <div v-show="showDetail">
      <div
        v-if="isLoading"
        class="border-t flex justify-center p-[48px]"
      >
        <b-spinner variant="primary" />
      </div>
      <div
        v-else-if="isError"
        class="flex flex-col gap-[8px] justify-center items-center py-[12px]"
      >
        <div class="flex items-center gap-[8px]">
          <span class="k-info-circle text-[20px] text-[#828282]" />
          Terjadi kesalahan saat mengambil data order
        </div>
        <b-button
          variant="primary"
          size="sm"
          class="!flex items-center gap-[8px]"
          :disabled="isRetry"
          @click="retryFetchOrderInfo"
        >
          Coba Lagi
        </b-button>
      </div>
      <div
        v-else
        class="border-t grid grid-cols-3"
      >
        <div class="p-[14px]">
          <div class="text-[12px] text-black">
            Request Packing
          </div>
          <div class="text-[20px] text-black font-semibold my-[10px]">
            {{ printedData.requested.total }}
          </div>
          <div class="text-[10px] text-[#34A770]">
            Resi Komship : {{ printedData.requested.komship }}
          </div>
          <div class="text-[10px] text-[#08A0F7]">
            Resi Non Komship : {{ printedData.requested.non_komship }}
          </div>
          <div class="text-[10px] text-[#08A0F7]">
            Resi Marketplace : {{ printedData.requested.marketplace }}
          </div>
        </div>
        <div class="p-[14px] border-x">
          <div class="text-[12px] text-black">
            Sukses Terpacking
          </div>
          <div class="text-[20px] text-black font-semibold my-[10px]">
            {{ printedData.packaged.total }}
          </div>
          <div class="text-[10px] text-[#34A770]">
            Resi Komship : {{ printedData.packaged.komship }}
          </div>
          <div class="text-[10px] text-[#08A0F7]">
            Resi Non Komship : {{ printedData.packaged.non_komship }}
          </div>
          <div class="text-[10px] text-[#08A0F7]">
            Resi Marketplace : {{ printedData.packaged.marketplace }}
          </div>
        </div>
        <div class="p-[14px]">
          <div class="text-[12px] text-black">
            Sukses Terkirim
          </div>
          <div class="text-[20px] text-black font-semibold my-[10px]">
            {{ printedData.sent.total }}
          </div>
          <div class="text-[10px] text-[#34A770]">
            Resi Komship : {{ printedData.sent.komship }}
          </div>
          <div class="text-[10px] text-[#08A0F7]">
            Resi Non Komship : {{ printedData.sent.kompack }}
          </div>
          <div class="text-[10px] text-[#08A0F7]">
            Resi Marketplace : {{ printedData.sent.marketplace }}
          </div>
        </div>
      </div>
    </div>
  </div></template>

<script>
import { DAY_MONTH_YEAR, YEAR_MONTH_DAY } from '@/libs/formatDate'
import MonthSelect from 'flatpickr/dist/plugins/monthSelect'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import flatPickr from 'vue-flatpickr-component'
import '@/@core/scss/vue/libs/vue-flatpicker.scss'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { today } from '@/store/helpers'

export default {
  name: 'WarehouseCardOderInfo',
  components: {
    flatPickr,
  },
  props: {
    warehouse: {
      type: Object,
      default: () => ({}),
    },
    showByDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      month: YEAR_MONTH_DAY(today),
      flatpickrMonthly: {
        mode: 'single',
        locale: Indonesian,
        altInput: true,
        maxDate: today,
        plugins: [
          new MonthSelect({
            shorthand: true,
            dateFormat: 'Y-m-d',
            altFormat: 'M Y',
          }),
        ],
      },
      isLoading: false,
      showDetail: this.showByDefault,
      data: undefined,
      isError: false,
      isRetry: false,
    }
  },
  computed: {
    printedData() {
      return {
        requested: this.data?.requested || {
          total: 0,
          komship: 0,
          non_komship: 0,
        },
        packaged: this.data?.packaged || {
          total: 0,
          komship: 0,
          non_komship: 0,
        },
        sent: this.data?.sent || {
          total: 0,
          komship: 0,
        },
      }
    },
  },
  mounted() {
    if (this.showByDefault) {
      this.fetchOrderInfo()
    }
  },
  methods: {
    DAY_MONTH_YEAR,
    onChangeMonth() {
      if (!this.showDetail) {
        this.showDetail = true
      }
      this.fetchOrderInfo()
    },
    /**
     * Toggle the detail of the warehouse card order info with lazily loading the data.
     */
    toggleDetail() {
      this.showDetail = !this.showDetail
      if (!this.data) {
        this.fetchOrderInfo()
      }
    },
    /**
     * Fetch the order info of the warehouse from the server.
     */
    async fetchOrderInfo() {
      this.isLoading = true
      try {
        const res = await this.$http_new.get(`kompack/api/v1/information-order/partners/warehouses/${this.warehouse.warehouse_id}`, {
          params: {
            period: this.month,
          },
        })
        const { data } = res.data
        this.data = data
        this.isError = false
      } catch {
        this.isError = true
      } finally {
        this.isLoading = false
      }
    },
    /**
     * Retry the fetch of the order info if error occurs.
     */
    async retryFetchOrderInfo() {
      this.isRetry = true
      await this.fetchOrderInfo()
      this.isRetry = false
    },
  },
}
</script>
